import { RootState } from './store';

const selectors = {
  lawyerConnection: {
    isFetchingMessages: () => (state: RootState) =>
      state.lawyerConnection.pending.fetchMessages,
    getConnectionById: (id: string) => (state: RootState) =>
      state.lawyerConnection.connections[id]?.connection,
    getConnections: () => (state: RootState) =>
      state.lawyerConnection.connections,
    getMessagesById: (id: string) => (state: RootState) =>
      state.lawyerConnection.connections[id]?.messages,
    isSendingMessage: () => (state: RootState) =>
      state.lawyerConnection.pending.sendMessage,
    getUser: (id: string) => (state: RootState) =>
      state.lawyerConnection.connections[id]?.user,
    isFetchingUser: () => (state: RootState) =>
      state.lawyerConnection.pending.fetchUser,
    isFetchingConnection: () => (state: RootState) =>
      state.lawyerConnection.pending.fetchById,
    getLawyersByIds:
      (connectionId: string) => (state: RootState) =>
        state.lawyerConnection.connections[connectionId]?.lawyers,
    isFetchingLawyers: () => (state: RootState) =>
      state.lawyerConnection.pending.fetchLawyersByIds,
  },
  prematter: {
    isFetchingById: () => (state: RootState) =>
      state.prematter.pending.fetchById,
    getPrematterById: (id: string) => (state: RootState) =>
      state.prematter.data[id],
    isConvertingToMatter: () => (state: RootState) =>
      state.prematter.pending.convertToMatter,
    isFetchingByConnectionId: () => (state: RootState) =>
      state.prematter.pending.fetchByConnectionId,
  },
  file: {
    getFiles: (id: string) => (state: RootState) => state.file.connections[id],
    isFetchingFiles: () => (state: RootState) => state.file.pending.fetch,
    getFetchFilesError: () => (state: RootState) => state.file.errors.fetch,
    isSendingFiles: () => (state: RootState) => state.file.pending.send,
  },
};

export default selectors;
